import React from 'react'

import classes from './LargeExclamation.module.scss'
import exclamation from '../../assets/images/general-icons/exclamation.svg'

export const LargeExclamation = () => (
  <div className={classes.largeExclamationWrapper}>
    <img
      alt="An exclamation icon"
      src={exclamation}
      data-testid="exclamation-icon"
    />
  </div>
)

export default LargeExclamation
